(() => {
  'use strict';

  if (window.__magneoCustomPhotoCartInstalled) return;
  window.__magneoCustomPhotoCartInstalled = true;

  const CUSTOM_ID = '49045152301312';
  const PHOTOS_PER_BOX = 9;
  const HELP_SELECTOR = '[data-magneo-photo-method]';
  const UPLOAD_SELECTOR = '#photouploadapp';
  const ADD_SELECTOR = 'button[name="add"], [id^="ProductSubmitButton-"], [data-add-to-cart], .product-form__submit, .sticky-atc-button';
  const PHOTO_FIELDS = ['Upload 9 Photos for Your Covers', 'Box 2 - Upload 9 Photos'];
  const nativeStates = new Map();
  const completions = new Map();
  let automaticIntent = null;
  let intentSequence = 0;

  function copy(key, values = {}) {
    let text = window.MagneoDoneCopy?.[key] || '';
    Object.entries(values).forEach(([name, value]) => {
      text = text.replaceAll(`__${name}__`, String(value));
    });
    return text;
  }

  function status(key) {
    const help = document.querySelector(HELP_SELECTOR);
    if (!help) return;
    let node = help.querySelector('[data-magneo-done-status]');
    if (!node && key) {
      node = document.createElement('p');
      node.className = 'magneo-photo-method__help';
      node.setAttribute('data-magneo-done-status', '');
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      help.append(node);
    }
    if (!node) return;
    const message = key ? copy(key) : '';
    if (node.textContent !== message) node.textContent = message;
    node.hidden = !message;
  }

  function cancelAutomatic(clearStatus = true) {
    automaticIntent = null;
    intentSequence += 1;
    if (clearStatus) status('');
  }

  function mainForm() {
    return document.querySelector('product-form form[action*="/cart/add"]');
  }

  function activeCard() {
    const checked = document.querySelector('.quantity-breaks-container input[name="quantity"]:checked');
    if (!checked) return null;
    if (checked.nextElementSibling?.matches('.quantity-break')) return checked.nextElementSibling;
    const id = checked.id && CSS.escape(checked.id);
    return id ? document.querySelector(`label.quantity-break[for="${id}"]`) : null;
  }

  function variantIds(form) {
    const cardIds = [...(activeCard()?.querySelectorAll('.quantity-break__variant-select') || [])]
      .map(select => String(select.value)).filter(Boolean);
    if (cardIds.length) return cardIds;

    const bundleIds = [...form.querySelectorAll('input[name^="items["][name$="[id]"]')]
      .map(input => String(input.value)).filter(Boolean);
    if (bundleIds.length) return bundleIds;

    return String(form.querySelector('input[name="id"]')?.value || '')
      .split(',').map(id => id.trim()).filter(Boolean);
  }

  function setCustomDefault() {
    if (window.__magneoDefaultVariantApplied) return true;
    if (new URLSearchParams(window.location.search).has('variant')) return true;
    const selects = [...document.querySelectorAll('.quantity-break__variant-select')];
    if (!document.querySelector('.quantity-breaks-container') || !selects.length) return false;
    if (!selects.some(select => select.querySelector(`option[value="${CUSTOM_ID}"]`))) return true;

    selects.forEach(select => {
      const option = select.querySelector(`option[value="${CUSTOM_ID}"]`);
      if (!option || option.disabled) return;
      select.value = CUSTOM_ID;
      [...select.options].forEach(choice => {
        choice.selected = choice === option;
        choice.toggleAttribute('selected', choice === option);
      });
    });

    const formId = mainForm()?.querySelector('input[name="id"]');
    if (formId) {
      formId.value = CUSTOM_ID;
      formId.dataset.selectedId = CUSTOM_ID;
    }
    const selected = [...(activeCard()?.querySelectorAll('.quantity-break__variant-select') || [])];
    selected.forEach((select, index) => {
      if (typeof window.quantityBreakVariantChange === 'function') {
        window.quantityBreakVariantChange({ target: select }, selected.length, index + 1);
      }
    });
    if (selected[0]) selected[0].dispatchEvent(new Event('change', { bubbles: true }));
    window.__magneoDefaultVariantApplied = true;
    return true;
  }

  function retryCustomDefault(attempt = 0) {
    if (setCustomDefault() || attempt >= 20) return;
    window.setTimeout(() => retryCustomDefault(attempt + 1), 100);
  }

  let lastRequired = null;
  function syncUpload() {
    const help = document.querySelector(HELP_SELECTOR);
    const form = mainForm();
    if (!help || !form) return;
    const hasCustom = variantIds(form).includes(CUSTOM_ID);
    help.hidden = !hasCustom;

    const root = document.querySelector(UPLOAD_SELECTOR);
    const block = root?.closest('.shopify-app-block') || root;
    if (block) {
      block.hidden = !hasCustom;
      block.style.display = hasCustom ? '' : 'none';
      block.setAttribute('aria-hidden', hasCustom ? 'false' : 'true');
    }
    const field = window.__magneoUploadField;
    if (field?.updateConfig && lastRequired !== false) {
      field.updateConfig({ required: false });
      lastRequired = false;
    }
    bindNativeFields();
    nativeStates.forEach(state => reconcile(state, form));
    advanceAutomatic(form);
  }

  function normalizedUrl(value) {
    try {
      const url = new URL(value.replace(/&amp;/g, '&'));
      return url.protocol === 'https:' && url.hostname.includes('.') ? url.href : null;
    } catch (_) {
      return null;
    }
  }

  function nativeElement(name) {
    return [...(document.querySelector(UPLOAD_SELECTOR)?.querySelectorAll('[id^="selBtn_"][data-ph-fieldname]') || [])]
      .find(element => element.getAttribute('data-ph-fieldname') === name);
  }

  function filesOf(group) {
    if (!group) return [];
    const files = group.files?.();
    if (!files) throw new Error('Invalid native selection');
    return [...files].filter(Boolean);
  }

  function sameFiles(a, b) {
    return a && b && a.length === b.length && a.every((file, index) => file === b[index]);
  }

  function infosOf(files) {
    return Promise.all(files.map(file => new Promise((resolve, reject) => {
      if (typeof file.done === 'function') {
        file.done(info => info?.uuid ? resolve(info) : reject(new Error('Missing file identifier')));
        file.fail?.(reject);
      } else if (file.uuid) resolve(file);
      else reject(new Error('Invalid native file'));
    })));
  }

  function trackSelection(state, group) {
    let files;
    try { files = filesOf(group); } catch (_) {
      state.failed = true;
      state.ready = false;
      scheduleSync();
      return;
    }
    if (sameFiles(state.files, files)) return;
    if (automaticIntent && !sameFiles(automaticIntent.expected.get(state.name), files)) cancelAutomatic();
    const revision = ++state.revision;
    state.files = files;
    state.infos = null;
    state.ready = false;
    state.failed = false;
    state.urls = null;
    infosOf(files).then(infos => {
      if (nativeStates.get(state.name) !== state || !state.element.isConnected || state.revision !== revision) return;
      state.infos = infos;
      scheduleSync();
    }).catch(() => {
      if (nativeStates.get(state.name) !== state || state.revision !== revision) return;
      state.failed = true;
      scheduleSync();
    });
  }

  function bindNativeFields() {
    PHOTO_FIELDS.forEach(name => {
      const element = nativeElement(name);
      const key = element?.id.slice('selBtn_'.length);
      const api = key && window.UPLOADCARE_DATA?.[key];
      let widget;
      try { widget = api?.widget || api?.ensure_widget?.(); } catch (_) { widget = null; }
      const old = nativeStates.get(name);
      if (old && old.element === element && old.widget === widget) return;
      if (old) {
        old.widget.onChange?.remove?.(old.onChange);
        old.widget.onDialogOpen?.remove?.(old.onDialogOpen);
        nativeStates.delete(name);
        completions.delete(old.key);
        cancelAutomatic();
      }
      if (!element || typeof widget?.onChange !== 'function' || typeof widget.onDialogOpen !== 'function') return;
      const state = { name, element, key, widget, revision: 0, dialogVersion: 0, open: false, files: null, infos: null, ready: false, failed: false, urls: null };
      nativeStates.set(name, state);
      state.onChange = group => {
        if (nativeStates.get(name) === state && element.isConnected) trackSelection(state, group);
      };
      state.onDialogOpen = dialog => {
        if (nativeStates.get(name) !== state || !element.isConnected || typeof dialog?.done !== 'function' || typeof dialog.always !== 'function') return;
        const dialogVersion = ++state.dialogVersion;
        state.open = true;
        cancelAutomatic();
        const error = document.querySelector(`${HELP_SELECTOR} [data-magneo-photo-error]`);
        if (error) error.hidden = true;
        dialog.done(group => {
          if (nativeStates.get(name) !== state || !element.isConnected || state.dialogVersion !== dialogVersion || !group || requestInFlight) return;
          const form = mainForm();
          if (!form || !variantIds(form).includes(CUSTOM_ID)) return;
          let files;
          try { files = filesOf(group); } catch (_) { showError(copy('order_error')); return; }
          if (!files.length) return;
          const expected = new Map([...nativeStates].map(([field, current]) => [field, current.files]));
          expected.set(name, files);
          automaticIntent = {
            sequence: ++intentSequence,
            ids: variantIds(form).join(','),
            expected,
            bindings: new Map(nativeStates),
            started: performance.now()
          };
          trackSelection(state, group);
          status('checking');
          scheduleSync();
        });
        dialog.fail?.(() => {
          if (nativeStates.get(name) === state && state.dialogVersion === dialogVersion) cancelAutomatic();
        });
        dialog.always(() => {
          if (nativeStates.get(name) !== state || state.dialogVersion !== dialogVersion) return;
          state.open = false;
          window.setTimeout(() => {
            if (nativeStates.get(name) !== state || !element.isConnected) return;
            try { state.onChange(widget.value?.() || null); } catch (_) { state.failed = true; }
            scheduleSync();
          }, 0);
        });
        scheduleSync();
      };
      widget.onChange(state.onChange);
      widget.onDialogOpen(state.onDialogOpen);
      try { state.onChange(widget.value?.() || null); } catch (_) { state.failed = true; }
    });
  }

  function photoSlots(form, fieldName) {
    const root = document.querySelector(UPLOAD_SELECTOR);
    const slots = new Map();
    const metadata = new Map();
    const addValue = (name, value, input = null) => {
      const property = /^properties\[(.+)\]$/i.exec(name);
      if (!property || (property[1] !== fieldName && !property[1].startsWith(`${fieldName} `))) return;
      const suffix = property[1].slice(fieldName.length).trim();
      if (suffix && !/^\d+$/.test(suffix)) return;
      const slot = suffix ? Number(suffix) : 1;
      if (!Number.isSafeInteger(slot) || slot < 1) return;
      if (!slots.has(slot)) slots.set(slot, new Set());
      const cdn = normalizedUrl(input?.getAttribute?.('data-cdn') || '');
      let uuid = input?.closest?.('[data-img-id]')?.getAttribute('data-img-id');
      if (!uuid && cdn) uuid = new URL(cdn).pathname.split('/').filter(Boolean)[0];
      if (cdn && uuid) {
        if (!metadata.has(slot)) metadata.set(slot, new Map());
        metadata.get(slot).set(`${uuid}|${cdn}`, { uuid, cdn });
      }
      (String(value || '').match(/https?:\/\/[^\s,"'<>]+/gi) || []).forEach(raw => {
        const url = normalizedUrl(raw);
        if (url) slots.get(slot).add(url);
      });
    };
    new FormData(form).forEach((value, name) => {
      if (typeof value === 'string') addValue(name, value);
    });
    new Set([...form.elements, ...(root?.querySelectorAll('input, textarea') || [])])
      .forEach(input => addValue(input.name || '', input.value || '', input));
    const entries = [...slots].filter(([, values]) => values.size).sort(([a], [b]) => a - b);
    return {
      urls: entries.map(([, values]) => [...values][0]),
      metadata: entries.map(([number]) => metadata.get(number)?.size === 1 ? [...metadata.get(number).values()][0] : null),
      count: entries.length,
      conflict: entries.some(([, values]) => values.size !== 1),
      gap: entries.some(([number], index) => number !== index + 1)
    };
  }

  function matchesInfo(info, uuid, cdn) {
    return info.uuid === uuid && (!info.cdnUrl || normalizedUrl(info.cdnUrl) === cdn);
  }

  function supplierPhotoUrl(uuid) {
    if (typeof uuid !== 'string' || !uuid) return null;
    // Uploadly's hidden property and completion event use this UUID encoding.
    return normalizedUrl(`https://cdn.upstorage.io/u/${uuid.split('-').map(part => part.slice(-3)).join('')}`);
  }

  function reconcile(state, form) {
    state.ready = false;
    if (state.open || state.failed || !state.infos || !state.element.isConnected) return;
    try {
      const currentFiles = filesOf(state.widget.value?.() || null);
      if (!sameFiles(currentFiles, state.files)) { trackSelection(state, state.widget.value?.() || null); return; }
    } catch (_) { state.failed = true; return; }
    const photos = photoSlots(form, state.name);
    if (photos.conflict || photos.gap || photos.count !== state.infos.length) return;
    const event = completions.get(state.key);
    const eventMatches = event && event.files.length === state.infos.length &&
      event.files.every((file, index) => matchesInfo(state.infos[index], file.uuid, normalizedUrl(file.cdnUrl || '')));
    if (eventMatches) {
      const urls = event.files.map(file => normalizedUrl(file.uploadlyUrl || ''));
      if (urls.some(url => !url) || photos.urls.some((url, index) => url !== urls[index])) return;
    } else if (photos.metadata.some((meta, index) => !meta || !matchesInfo(state.infos[index], meta.uuid, meta.cdn)) ||
      photos.urls.some((url, index) => url !== supplierPhotoUrl(state.infos[index].uuid))) return;
    state.ready = true;
    state.urls = photos.urls;
  }

  function photoPlan(form, automatic = false) {
    const count = variantIds(form).filter(id => id === CUSTOM_ID).length;
    const fields = PHOTO_FIELDS.map(name => photoSlots(form, name));
    const total = fields.reduce((sum, photos) => sum + photos.count, 0);
    if (!count) return { boxes: [] };
    if (!total && !automatic && !uploadUnfinished()) {
      const nativeUploadActive = [...nativeStates.values()].some(state => state.open || state.failed || state.files?.length);
      const unresolvedPhoto = document.querySelector(`${UPLOAD_SELECTOR} [data-img-id], ${UPLOAD_SELECTOR} [data-prev-id]`);
      if (!nativeUploadActive && !unresolvedPhoto) return { boxes: Array.from({ length: count }, () => []) };
    }
    for (const [index, name] of PHOTO_FIELDS.entries()) {
      const element = nativeElement(name);
      const state = nativeStates.get(name);
      if (state?.failed) return { error: copy('upload_error') };
      if (state?.open || (element && (!state || !state.ready)) ||
        (fields[index].count && (!element || !state?.element.isConnected || !state.ready))) return { pending: true };
    }
    if (uploadUnfinished()) return { pending: true };
    if (fields.some(photos => photos.conflict || photos.gap)) return { error: copy('order_error') };
    if (count === 1 && fields[0].count === 9 && fields[1].count === 0) return { boxes: [fields[0].urls] };
    if (count === 2 && fields[0].count === 18 && fields[1].count === 0) return { boxes: [fields[0].urls.slice(0, 9), fields[0].urls.slice(9)] };
    if (count === 2 && fields[0].count === 9 && fields[1].count === 9) return { boxes: fields.map(photos => photos.urls) };
    if (count === 2 && total === 9 && fields.every(photos => photos.count === 0 || photos.count === 9)) return { incomplete: true };
    return { error: total === count * PHOTOS_PER_BOX ? copy('order_error') : copy('count_error', { required: count * PHOTOS_PER_BOX, count: total }) };
  }

  function advanceAutomatic(form) {
    const intent = automaticIntent;
    if (!intent || requestInFlight) return;
    if (intent.ids !== variantIds(form).join(',') || [...intent.bindings].some(([name, state]) => nativeStates.get(name) !== state || !state.element.isConnected)) {
      cancelAutomatic();
      return;
    }
    if ([...nativeStates].some(([name, state]) => !sameFiles(intent.expected.get(name), state.files))) {
      cancelAutomatic();
      return;
    }
    if (performance.now() - intent.started > 60000) {
      cancelAutomatic();
      showError(copy('timeout'));
      return;
    }
    const plan = photoPlan(form, true);
    if (plan.pending) return;
    if (plan.incomplete) {
      cancelAutomatic(false);
      status('remaining');
      return;
    }
    if (plan.error !== undefined) {
      cancelAutomatic();
      showError(plan.error);
      return;
    }
    const button = form.querySelector(ADD_SELECTOR);
    if (!button || button.disabled) return;
    automaticIntent = null;
    addToCart(button, form, true);
  }

  function uploadUnfinished() {
    const root = document.querySelector(UPLOAD_SELECTOR);
    return Boolean(root?.querySelector(
      '.uploadcare--widget_status_started, .uploadcare--widget_status_uploading, .uploadcare--widget_status_error, [aria-busy="true"]'
    )) || /uploading|processing|upload failed|failed to upload/i.test(root?.innerText || '');
  }

  function sharedProperties(form) {
    const properties = {};
    new FormData(form).forEach((value, key) => {
      const match = /^properties\[(.+)\]$/.exec(key);
      if (!match || typeof value !== 'string' || !value.trim()) return;
      if (/upload|photo|image|file|Custom edition|_Magneo Custom Preview/i.test(match[1])) return;
      properties[match[1]] = value;
    });
    return properties;
  }

  function cartPayload(form, automatic = false) {
    const ids = variantIds(form);
    bindNativeFields();
    nativeStates.forEach(state => reconcile(state, form));
    const plan = photoPlan(form, automatic);
    if (plan.error !== undefined) return { error: plan.error };
    if (plan.pending) return { error: copy('checking') };
    if (plan.incomplete) return { error: copy('remaining') };
    const shared = sharedProperties(form);
    const customTotal = ids.filter(id => id === CUSTOM_ID).length;
    let customIndex = 0;
    return {
      items: ids.map(rawId => {
        const properties = { ...shared };
        if (rawId === CUSTOM_ID) {
          const boxUrls = plan.boxes[customIndex] || [];
          properties['Photo submission'] = boxUrls.length === PHOTOS_PER_BOX
            ? 'Uploaded before checkout' : 'Email after checkout';
          if (customTotal > 1) properties['Custom box'] = `${customIndex + 1} of ${customTotal}`;
          boxUrls.forEach((url, index) => { properties[`Custom photo ${index + 1}`] = url; });
          customIndex += 1;
        }
        return { id: Number(rawId), quantity: 1, properties };
      })
    };
  }

  function showError(message) {
    const error = document.querySelector(`${HELP_SELECTOR} [data-magneo-photo-error]`);
    if (!error) return;
    error.textContent = message || error.dataset.fallback || 'Could not add to cart';
    error.hidden = false;
    error.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  let requestInFlight = false;
  async function addToCart(source, form, automatic = false) {
    if (requestInFlight) return;
    const payload = cartPayload(form, automatic);
    if (payload.error !== undefined) {
      cancelAutomatic();
      showError(payload.error);
      return;
    }
    if (!payload.items.length || payload.items.some(item => !Number.isSafeInteger(item.id) || item.id <= 0)) {
      showError();
      return;
    }
    const error = document.querySelector(`${HELP_SELECTOR} [data-magneo-photo-error]`);
    if (error) error.hidden = true;
    const button = source?.matches?.(ADD_SELECTOR) ? source : form.querySelector(ADD_SELECTOR);
    cancelAutomatic(false);
    requestInFlight = true;
    status('adding');
    if (button) button.disabled = true;
    try {
      const base = window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add`;
      const response = await fetch(base.replace(/\.js$/, '') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || '');
      window.location.assign(window.routes?.cart_url || '/cart');
    } catch (error) {
      status('');
      showError(error.message || copy('add_failed'));
      if (button) button.disabled = false;
      requestInFlight = false;
    }
  }

  function intercept(source, event) {
    const form = mainForm();
    if (!document.querySelector(HELP_SELECTOR) || !form) return;
    if (source.matches?.('form') && source !== form) return;
    if (source.matches?.(ADD_SELECTOR) && source.form !== form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addToCart(source, form);
  }

  window.addEventListener('click', event => {
    const button = event.target.closest?.(ADD_SELECTOR);
    if (button && !button.disabled) intercept(button, event);
  }, true);
  window.addEventListener('submit', event => {
    if (event.target.matches?.('form[action*="/cart/add"]')) intercept(event.target, event);
  }, true);

  let timer = 0;
  function scheduleSync() {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncUpload, 80);
  }
  document.addEventListener('change', event => {
    if (event.target.matches('.quantity-breaks-container input[name="quantity"], .quantity-breaks-container .quantity-break__variant-select')) {
      cancelAutomatic();
      scheduleSync();
    }
  });
  window.addEventListener('upload:ready', () => {
    lastRequired = null;
    scheduleSync();
  });
  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('uploadly:upload-complete', event => {
    if (!PHOTO_FIELDS.includes(event.detail?.fieldName) || !Array.isArray(event.detail?.files)) return;
    completions.set(String(event.detail.fieldId), { files: event.detail.files });
    scheduleSync();
  });

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'value']
  });
  retryCustomDefault();
  scheduleSync();
  window.setInterval(() => {
    if (automaticIntent || [...nativeStates.values()].some(state => !state.ready) ||
        (document.querySelector(UPLOAD_SELECTOR) && nativeStates.size < PHOTO_FIELDS.length)) scheduleSync();
  }, 400);
})();
